var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 132,
    viewBox: "0 0 292 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillRule: "nonzero",
    d: "M83.4 91.4h155.3c1.6 0 2.8-1.3 2.8-2.8v-85c0-1.6-1.3-2.8-2.8-2.8H83.4c-1.6 0-2.8 1.3-2.8 2.8v85c0 1.6 1.2 2.8 2.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M161.5.8H83.6c-1.6 0-2.8 1.3-2.8 2.8v85.1c0 1.6 1.3 2.8 2.8 2.8M238.6 91.6c1.6 0 2.8-1.3 2.8-2.8V46.2M230.9 49.8V17.7c0-2.7-2.2-4.9-4.9-4.9h-64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeDasharray: "15,7",
    strokeWidth: 2,
    d: "M103.4 104.4h125.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M67.5 129.6h188l-14.9-38H80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M175.5 117.6h-28l-4 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    fillRule: "nonzero",
    d: "M116.6 72.4l42.9-25c2.7-1.6 3.6-5.1 2-7.8l-14.4-24.8c-1.6-2.7-5.1-3.6-7.8-2l-42.9 25c-2.7 1.6-3.6 5.1-2 7.8l14.4 24.8c1.7 2.6 5.1 3.5 7.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M116.6 72.4l42.9-25c2.7-1.6 3.6-5.1 2-7.8l-14.4-24.8c-1.6-2.7-5.1-3.6-7.8-2l-42.9 25c-2.7 1.6-3.6 5.1-2 7.8l14.4 24.8c1.7 2.6 5.1 3.5 7.8 2zM96.1 48.4l52.7-30.7M98.6 52.8L151.3 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    fillRule: "nonzero",
    d: "M137.2 78.6h49.7c3.1 0 5.7-2.6 5.7-5.7V44.2c0-3.1-2.6-5.7-5.7-5.7h-49.7c-3.1 0-5.7 2.6-5.7 5.7v28.7c0 3.1 2.6 5.7 5.7 5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M161.5 38.6h-24.3c-3.1 0-5.7 2.6-5.7 5.7V73c0 3.1 2.6 5.7 5.7 5.7h49.6c3.1 0 5.7-2.6 5.7-5.7V58.6M138.5 47.6h46M138.5 60.6h21M138.5 67.6h21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M166.5 60.6h18v10h-18zM192.1 23.2h29.7v14.6h-29.7z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3 83.1l-1.7-.3c-.2-.6-.4-1.1-.7-1.6l1-1.4c.4-.6.4-1.4-.2-1.9l-1.5-1.5c-.3-.3-.7-.4-1-.4-.3 0-.6.1-.9.3l-1.4 1c-.5-.3-1.1-.5-1.7-.7l-.2-1.8c-.1-.7-.7-1.2-1.5-1.2h-2.1c-.7 0-1.3.5-1.5 1.2l-.3 1.7c-.6.2-1.1.4-1.6.7l-1.4-1c-.6-.4-1.4-.4-1.9.2l-1.5 1.5c-.5.5-.6 1.3-.2 1.9l1 1.4c-.3.5-.5 1.1-.7 1.6l-1.7.3c-.7.1-1.2.7-1.2 1.5v2.1c0 .7.5 1.3 1.2 1.5l1.7.3c.2.6.4 1.1.7 1.6l-1 1.4c-.4.6-.4 1.4.2 1.9l1.5 1.5c.3.3.7.4 1 .4.3 0 .6-.1.9-.3l1.4-1c.5.3 1 .5 1.6.7l.4 1.6c.1.7.7 1.2 1.5 1.2h2.1c.7 0 1.3-.5 1.5-1.2l.3-1.7c.6-.2 1.1-.4 1.6-.7l1.4 1c.3.2.6.3.9.3.4 0 .8-.2 1-.4l1.5-1.5c.5-.5.6-1.3.2-1.9L50 90c.3-.5.5-1.1.7-1.6l1.7-.3c.7-.1 1.2-.7 1.2-1.5v-2.1c-.1-.7-.6-1.3-1.3-1.4zm-.1 3.5c0 .1 0 .1-.1.1l-2.1.4c-.3 0-.5.2-.5.5-.2.7-.5 1.4-.9 2.1-.1.2-.1.5 0 .7l1.2 1.7v.2l-1.5 1.5h-.1-.1l-1.7-1.2c-.2-.2-.5-.2-.7 0-.7.4-1.4.7-2.2.9-.2 0-.4.3-.5.5l-.4 2.1c0 .1-.1.1-.1.1h-2.1c-.1 0-.1 0-.1-.1L40 94c0-.3-.2-.5-.5-.5-.7-.2-1.4-.5-2.1-.8-.1-.1-.2-.1-.3-.1-.1 0-.3 0-.4.1l-1.8 1.2h-.1-.1l-1.5-1.5s-.1-.1 0-.2l1.2-1.7c.2-.2.2-.5 0-.7-.4-.7-.7-1.4-.9-2.1-.1-.3-.3-.4-.5-.5l-2-.4c-.1 0-.1-.1-.1-.1v-2.1c0-.1 0-.1.1-.1l2.1-.4c.3 0 .5-.2.5-.5.2-.7.5-1.4.9-2.1.1-.2.1-.5 0-.7L33.2 79v-.2l1.5-1.5h.2l1.7 1.2c.2.2.5.2.7 0 .7-.4 1.4-.7 2.1-.9.3-.1.4-.3.5-.5l.4-2.1c0-.1.1-.1.1-.1h2.1c.1 0 .1 0 .1.1l.4 2.1c0 .3.2.5.5.5.8.2 1.5.5 2.2.9.2.1.5.1.7 0l1.7-1.2h.2l1.5 1.5s.1.1 0 .2l-1.2 1.7c-.2.2-.2.5 0 .7.4.7.7 1.4.9 2.1.1.3.3.5.5.5l2.1.4c.1 0 .1.1.1.1v2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 80.6c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.7c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7 3.7 1.7 3.7 3.7-1.7 3.7-3.7 3.7z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M291.5 35.7h-36M265.5 30.5l-14 .1M63.5 53.6H.5M55.5 59.6h-16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.5,
    cy: 9.6,
    r: 6,
    stroke: "#C5C5C5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 28.6,
    r: 13,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M58.5 15.8c-7 0-12.7 5.7-12.7 12.7 0 7 5.7 12.7 12.7 12.7 7 0 12.7-5.7 12.7-12.7"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#9D9D9D",
    fontFamily: "ProximaNova-Regular, Proxima Nova",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54.698,
    y: 33
  }, "$")), /*#__PURE__*/React.createElement("g", {
    stroke: "#C5C5C5",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.5 88.9v17.3M271.5 97.6h18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillRule: "nonzero",
    d: "M215.1 45.6h53v28h-53z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M268.1 73.6h-53v-27h26.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "nonzero",
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M263.6 65.1v-11c-1.7 0-3-1.3-3-3h-38c0 1.7-1.3 3-3 3v11c1.7 0 3 1.3 3 3h38c0-1.7 1.3-3 3-3z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#9D9D9D",
    fontFamily: "ProximaNova-Regular, Proxima Nova",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 237.698,
    y: 64
  }, "$")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPayments);
export default __webpack_public_path__ + "static/media/noPayments.ef4418c36fa387d25ee70e387fe4b3d5.svg";
export { ForwardRef as ReactComponent };